import { render, staticRenderFns } from "./travel-tourism.vue?vue&type=template&id=f031fdc4&scoped=true&"
import script from "./travel-tourism.vue?vue&type=script&lang=js&"
export * from "./travel-tourism.vue?vue&type=script&lang=js&"
import style0 from "./travel-tourism.vue?vue&type=style&index=0&id=f031fdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f031fdc4",
  null
  
)

export default component.exports